export const discountTypeSelectOptions = [
  {
    value: '1',
    text: '$',
  },
  {
    value: '2',
    text: '%',
  },
];
